<template>
  <div>
    <div class="past-projects__err" arai-atomic="true" aria-live="assertive" role="alert">
      <slot name="err" v-if="error">
        <p class="past-projects__err-msg">Error retrieving projects.</p>
        <button @click="loadProjects" class="past-projects__err-btn">Reload</button>
      </slot>
    </div>

    <ul class="past-project-listing" v-if="!error">
      <li
        :class="selectedComponent == 'ProjectsGrid' ? 'past-project-listed-items' : ''"
        v-for="(project, index) in paginatedProjects"
        :key="project.id"
        style="display: flex; flex-direction: row"
        :style="
          selectedComponent == 'ProjectsList'
            ? 'width: 100%'
            : 'display: inline-block !important; width: 17rem; height: 21rem; margin: 1.5rem 2rem; position: relative;'
        "
      >
        <input
          type="checkbox"
          class="datasets__table-checkbox"
          @click="addToShowProjectsCheckOptions(project)"
          name="project-checkbox"
          :id="'project-checkbox-' + project.id"
          style="width: 1.3rem; height: 1.3rem; cursor: pointer; display: flex"
          :style="
            selectedComponent == 'ProjectsList'
              ? 'margin: auto;'
              : 'margin-right: auto; margin-top: 50%; margin-bottom: auto; position: absolute;'
          "
          v-model="selectedBoxes[index]"
        />
        <div
          style="
            z-index: 100;
            background-color: white;
            border-top: 0;
            border-radius: 0 0 4px 4px;
            color: var(--base-colour);
            position: absolute;
            margin-top: 2rem;
            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
            border: 1px solid var(--outline-colour);
            border-radius: 8px;
            margin-left: 3rem;
            width: 13rem;
          "
          v-if="
            showProjectsCheckOptions.length &&
            showProjectsCheckOptions[showProjectsCheckOptions.length - 1].id == project.id
          "
        >
          <div style="margin-left: 0.5rem">
            <VisibleText> {{ checkedProjects.length }} projects selected</VisibleText>
          </div>
          <div
            class="theme-options-btn"
            @click="onClickRename"
            v-if="showProjectsCheckOptions.length == 1"
          >
            <VisibleText>Rename</VisibleText>
          </div>
          <div
            class="theme-options-btn"
            @click="onClickReport"
            v-if="showProjectsCheckOptions.length == 1 && hasReport(project)"
          >
            <VisibleText>Open e-report</VisibleText>
          </div>
          <div
            class="theme-options-btn"
            @click="onClickEdit"
            v-if="showProjectsCheckOptions.length == 1"
          >
            <VisibleText>Open project</VisibleText>
          </div>
          <div
            class="theme-options-btn"
            @click="onClickDuplicate"
            v-if="showProjectsCheckOptions.length == 1 && isOwner(project)"
          >
            <VisibleText>Duplicate project</VisibleText>
          </div>
          <div
            class="theme-options-btn"
            @click="onClickShare"
            v-if="showProjectsCheckOptions.length == 1 && isOwner(project)"
          >
            <VisibleText>Share</VisibleText>
          </div>
          <div class="theme-options-btn" @click="onClickDelete">
            <VisibleText>Delete</VisibleText>
          </div>
        </div>
        <router-link
          :to="lastOpenedTab(project)"
          style="width: 97%; text-decoration: none; color: inherit"
        >
          <ProjectsList
            v-if="selectedComponent == 'ProjectsList'"
            :project="project"
            :datasetProjects="foundDatasets"
            style="background-color: white; cursor: pointer"
            :setToEdit="setToEdit.includes(project.id) ? true : false"
            :setToReport="setToReport.includes(project.id) ? true : false"
            :setToShare="setToShare.includes(project.id) ? true : false"
            :setToRename="setToRename.includes(project.id) ? true : false"
          >
          </ProjectsList>
        </router-link>

        <ProjectsGrid
          v-if="selectedComponent == 'ProjectsGrid'"
          :project="project"
          :datasetProjects="foundDatasets"
          :setToEdit="setToEdit.includes(project.id) ? true : false"
          :setToReport="setToReport.includes(project.id) ? true : false"
          :setToShare="setToShare.includes(project.id) ? true : false"
          :setToRename="setToRename.includes(project.id) ? true : false"
        >
        </ProjectsGrid>
      </li>
    </ul>
    <div v-if="paginatedProjects.length && paginatedProjects.length < searchLength">
      <button class="past-project-button" @click="onClickLoadMorePrjects">
        Load more projects
      </button>
    </div>
  </div>
</template>

<script>
import ProjectsList from '@/components/Projects/ProjectsList.vue';
import ProjectsGrid from '@/components/Projects/ProjectsGrid.vue';
import ConfirmMixin from '@/utils/mixins/confirmMixin.js';
import { PigeonDocCollectionModel, PigeonDocModel } from '@/pigeondoc/wrapper';
import { fetchProject } from '@/components/Project/Utils/fetch.js';
import BenchmarkingProject from '@/models/BenchmarkingProjectModel.js';
import TextService from '@/services/textService.js';

export default {
  name: 'PastProjects',
  props: {
    models: {
      type: Array,
      required: true,
    },
    search: {
      default: () => '',
      type: String,
    },
    sortOrder: {
      default: () => 'des',
      type: String,
    },
    selectedComponent: {
      default: () => 'ProjectsList',
      type: String,
    },
    foundDatasets: {
      type: Array,
      default: () => [],
    },
    // Moved these to frontend javascript filtering instead of sent through an API
    // where: {
    //   type: Object
    // },
    // sort: {
    //   type: Object
    // }
  },
  components: {
    ProjectsList,
    ProjectsGrid,
  },
  mixins: [ConfirmMixin],
  data() {
    return {
      error: false,
      projects: [],
      paginatedProjects: [],
      sortedProjects: [],
      pagination: {
        endIndx: 10,
        limit: 10,
        startIndx: 0,
      },
      searchLength: 0,
      sortBy: 'date',
      selectedBoxes: [],
      showProjectsCheckOptions: [],
      checkedProjects: [],
      setToEdit: [],
      setToReport: [],
      setToShare: [],
      setToRename: [],
      BenchmarkingProject: BenchmarkingProject,
      TEXT_SERVICE: new TextService(this.$pigeonline),
    };
  },
  async mounted() {
    this.loadProjects();
  },
  watch: {
    search: function () {
      this.filterProjects();
    },
    sortOrder() {
      this.filterProjects();
    },
    confirmStatus: async function (val) {
      if (val && this.confirmSourceComponent === 'projects' && this.confirmType === 'delete') {
        this.deleteProjects();
      }
    },
    // sort: {
    //   handler() {
    //     this.loadProjects()
    //   },
    //   deep: true
    // }
  },
  methods: {
    deepCloneObj(obj) {
      // deep clones an object using JSON stringify (data loss might occur)
      if (Array.isArray(obj)) {
        return obj.map((item) => JSON.parse(JSON.stringify(item)));
      } else if (typeof obj == 'object') {
        return JSON.parse(JSON.stringify(obj));
      }
    },
    async loadProjects() {
      try {
        // reset error message
        this.error = false;

        let params = {
          truncate: true,
        };
        // Example of how API params were used
        // if (this.where) params = this.where
        //if (this.search && search.term && search.term.length) {
        // params['search'] = this.search
        //}
        //if (this.sort) params['sort'] = this.sort

        // We make a seperate call for each project type as the endpoint currently only supports
        // a single value via project_type
        const projects = await Promise.all(
          this.models.map(async (Model) => {
            const data = await this.$pigeonline.projects.get(Model, params);
            return data;
          }),
        );

        this.projects = projects.reduce((acc, curr) => {
          acc.push(...curr);
          return acc;
        });

        this.$emit('pastProjectsRetreived', this.projects);
        this.filterProjects();
      } catch (e) {
        // set error message
        this.error = true;
        //console.error(e);
        this.$emit('pastProjectsError');
      }
    },
    filterProjects() {
      this.sortedProjects = this.projects;
      if (this.search) {
        this.sortedProjects = this.sortedProjects.filter((project) =>
          project.name.toLowerCase().includes(this.search.toLowerCase()),
        );
        this.searchLength = this.sortedProjects.length;
      } else {
        this.searchLength = this.projects.length;
      }
      if (this.sortBy == 'date') {
        this.sortedProjects.sort((a, b) => {
          let dateA = new Date(a.last_modified_on.$date);
          let dateB = new Date(b.last_modified_on.$date);
          if (this.sortOrder == 'des') {
            return dateB - dateA;
          }
          return dateA - dateB;
        });
      }
      this.paginateProjects();
    },

    paginateProjects() {
      this.paginatedProjects = this.sortedProjects.slice(
        this.pagination.startIndx,
        this.pagination.endIndx,
      );
    },

    onClickLoadMorePrjects() {
      this.pagination.endIndx = this.pagination.endIndx + this.pagination.limit;
      this.paginateProjects();
    },

    addToShowProjectsCheckOptions(checked_project) {
      let found_id = checked_project.id; // TODO 1.10.0 this is being weird, the id is deleting itself
      let checkedProjects = this.checkedProjects;
      let checkedProjectsFilter = [];
      checkedProjectsFilter = checkedProjects.filter((project) => project.id == checked_project.id);
      if (checkedProjectsFilter.length) {
        this.checkedProjects = checkedProjects.filter(
          (project) => project.id != checked_project.id,
        );
      } else {
        checked_project.id = found_id;
        this.checkedProjects.push(checked_project);
      }
      let showProjectsCheckOptions = this.showProjectsCheckOptions;
      let opennedOption = [];
      opennedOption = showProjectsCheckOptions.filter((item) => item.id == checked_project.id);
      if (opennedOption.length) {
        this.showProjectsCheckOptions = showProjectsCheckOptions.filter(
          (item) => item.id != checked_project.id,
        );
      } else {
        this.showProjectsCheckOptions.push(checked_project);
      }
    },
    onClickEdit() {
      for (let i = 0; i < this.checkedProjects.length; i++) {
        this.setToEdit.push(this.checkedProjects[i].id);
      }
      this.showProjectsCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedProjects = [];
    },
    onClickReport() {
      for (let i = 0; i < this.checkedProjects.length; i++) {
        this.setToReport.push(this.checkedProjects[i].id);
      }
      this.showProjectsCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedProjects = [];
    },
    onClickRename() {
      this.setToRename = [];
      for (let i = 0; i < this.checkedProjects.length; i++) {
        this.setToRename.push(this.checkedProjects[i].id);
      }
      this.showProjectsCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedProjects = [];
    },
    onClickShare() {
      for (let i = 0; i < this.checkedProjects.length; i++) {
        this.setToShare.push(this.checkedProjects[i].id);
      }
      this.showProjectsCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedProjects = [];
    },
    async onClickDuplicate() {
      for (let a = 0; a < this.checkedProjects.length; a++) {
        let response = await this.$pigeonline.projects.getByID(
          BenchmarkingProject,
          this.checkedProjects[a].id,
        );
        if (response) {
          let newProject = this.deepCloneObj(response);
          if (newProject.textAnalysisObjects > 0) {
            for (let b = 0; b < newProject.textAnalysisObjects.length; b++) {
              let newAnalysis = this.deepCloneObj(newProject.textAnalysisObjects[b]);
              const oldUUID = newAnalysis.textAnalysisObjects.uuid;
              const newUUID = await this.$pigeonline.createUUID();
              newAnalysis.uuid = newUUID;
              // Duplicate themes which are saved separately
              let payload = {
                text_analysis_uuid: oldUUID,
              };
              let newThemes = [];
              const fetchedThemes = await this.TEXT_SERVICE.fetchTextThemes(payload);
              for (let i = 0; i < fetchedThemes.length; i++) {
                const themeToDuplicate = this.deepCloneObj(fetchedThemes[i]);
                let newTheme = themeToDuplicate;
                newTheme.created_on = moment().valueOf();
                newTheme.text_analysis_uuid = newUUID;
                delete newTheme._id;
                newThemes.push(newTheme);
              }
              if (newThemes.length) {
                let payload = {
                  themes: newThemes,
                  text_analysis_uuid: newUUID,
                };
                await this.TEXT_SERVICE.saveThemes(payload).then((response) => {
                  return response;
                });
              }
              // Create new Analysis
              newProject.textAnalysisObjects.unshift(newAnalysis); // Due to some asyncrosity, it seems to be sending a project update automatically
            }
          }
          if (newProject.driversAnalysis > 0) {
            for (let b = 0; b < newProject.driversAnalysis.length; b++) {
              let newAnalysis = this.deepCloneObj(newProject.driversAnalysis[b]);
              const newUUID = await this.$pigeonline.createUUID();
              newAnalysis.uuid = newUUID;
              newProject.driversAnalysis.unshift(newAnalysis);
            }
          }
          if (newProject.outliersAnalysis > 0) {
            for (let b = 0; b < newProject.outliersAnalysis.length; b++) {
              let newAnalysis = this.deepCloneObj(newProject.outliersAnalysis[b]);
              const newUUID = await this.$pigeonline.createUUID();
              newAnalysis.uuid = newUUID;
              newProject.outliersAnalysis.unshift(newAnalysis);
            }
          }
          if (newProject.benchmarkAnalysis > 0) {
            for (let b = 0; b < newProject.benchmarkAnalysis.length; b++) {
              let newAnalysis = this.deepCloneObj(newProject.benchmarkAnalysis[b]);
              const newUUID = await this.$pigeonline.createUUID();
              newAnalysis.uuid = newUUID;
              newProject.benchmarkAnalysis.unshift(newAnalysis);
            }
          }
          if (newProject.performanceAnalysis > 0) {
            for (let b = 0; b < newProject.performanceAnalysis.length; b++) {
              let newAnalysis = this.deepCloneObj(newProject.performanceAnalysis[b]);
              const newUUID = await this.$pigeonline.createUUID();
              newAnalysis.uuid = newUUID;
              newProject.performanceAnalysis.unshift(newAnalysis);
            }
          }
          if (newProject.collection_id) {
            newProject.collection_id = '';
          }
          if (newProject.report) {
            newProject.report = '';
          }
          if (newProject.status.reportCreated) {
            newProject.status.reportCreated = false;
          }

          delete newProject.id;
          delete newProject._id;
          await this.$pigeonline.projects.create(newProject);
        }
      }

      this.showProjectsCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedProjects = [];
      this.loadProjects();
    },
    onClickDelete() {
      this.setConfirmText({
        btn: 'Delete?',
        title: 'Delete projects?',
      });
      this.setConfirmType('delete');
      this.setConfirmSourceComponent('projects'); // double check
      this.setConfirmStatus(false);
      this.setConfirmIsVisible(this.checkedProjects.length > -1);
    },
    async deleteProjects() {
      for (let a = 0; a < this.checkedProjects.length; a++) {
        // Check for related themes inside any textAnalysisObjects to prevent zombie themes
        if (this.checkedProjects[a].textAnalysisObjects > 0) {
          const fullProject = await fetchProject(this.checkedProjects[a].id);

          if (fullProject.textAnalysisObjects && fullProject.textAnalysisObjects.length) {
            for (let a = 0; a < fullProject.textAnalysisObjects.length; a++) {
              let payload = {
                text_analysis_uuid: fullProject.textAnalysisObjects[a].uuid,
              };
              const fetchedThemes = await this.TEXT_SERVICE.fetchTextThemes(payload);
              const all_themes = fetchedThemes.map((theme) =>
                theme._id.$oid ? theme._id.$oid : theme._id,
              );
              if (all_themes.length) {
                let payload = {
                  _ids: all_themes,
                  text_analysis_uuid: fullProject.textAnalysisObjects[a].uuid,
                };
                await this.TEXT_SERVICE.deleteTextThemes(payload);
              }
            }
          }
        }

        if (this.checkedProjects[a].collection_id) {
          let collection = await this.$pigeonline.projects.getByID(
            PigeonDocCollectionModel,
            this.checkedProjects[a].collection_id,
          );
          if (collection && collection.id) {
            if (collection.docIds) {
              for (let i = 0; i < collection.docIds.length; i++) {
                let collection_report = await this.$pigeonline.projects.getByID(
                  PigeonDocModel,
                  collection.docIds[i],
                );
                if (collection_report && collection_report.id) {
                  await this.$pigeonline.projects.delete(collection.docIds[i]);
                }
              }
            }
            await this.$pigeonline.projects.delete(this.checkedProjects[a].collection_id);
          }
        }
        if (this.checkedProjects[a].report) {
          let report = await this.$pigeonline.projects.getByID(
            BenchmarkingProject,
            this.checkedProjects[a].report,
          );
          if (report && report.id) {
            await this.$pigeonline.projects.delete(this.checkedProjects[a].report);
          }
        }

        await this.$pigeonline.projects.delete(this.checkedProjects[a].id);
      }

      this.showProjectsCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedProjects = [];
      this.loadProjects();
    },

    isOwner(project) {
      return project.owner == this.$store.getters['user/getProfile'].django_ref_id;
    },
    hasReport(project) {
      return project.status.reportCreated;
    },
    lastOpenedTab(project) {
      if (project.settings) {
        if (project.settings.lastOpenedTab) {
          return '/project/' + project.id + '/analysis/' + project.settings.lastOpenedTab;
        }
      }
      return '/project/' + project.id;
    },
  },
};
</script>

<style>
.past-project-listing__item {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  border: 1px solid #777;
  margin-bottom: 1rem;
}

.past-project-listing__item__section {
  margin: 1rem;
}

.past-project-button {
  border-color: transparent;
  background-color: transparent;
  text-align: center;
  width: 100%;
  margin: 0 auto;
  color: var(--primary);
  font-size: 0.9rem;
}

.past-project-listed-items:first-child {
  margin-left: 23rem !important;
}
</style>
